module.exports = __webpack_public_path__ + "static/media/tot_active.dc1ca88b.svg";